import * as gateway from 'sfx-web-contract';
import { AlkLogger, isNil } from '@alk/core';
import { fullNotificationMap, notificationItemTypeMap } from '../../../helpers';
import {
    INotificationMessage,
    NotificationMessagesListTransaction,
} from '../../../interfaces';

export function bareboneNotificationMap(message: gateway.INotificationBarebone): INotificationMessage {
    return {
        id: message.Id,
        type: notificationItemTypeMap.get(message.Topic) || 'unknown',
        loaded: false,
    };
}

export const historicalTransformator = (notifications: Array<gateway.INotificationBarebone>): NotificationMessagesListTransaction => ({
    snapshot: notifications.map(bareboneNotificationMap),
});

export const incrementTransformator = (notifications: Array<gateway.INotification>): NotificationMessagesListTransaction => ({
    increment: notifications.map(fullNotificationMap),
});

export function validateNotification(notification: gateway.INotification): Error | gateway.INotification {

    if (isNaN(Date.parse(notification.Date))) {
        throw new Error('[NotificationsAdapterService#validateNotification] notification \'Date\' is not in ISO8601 date format');
    }

    if (notification.Topic === gateway.NotificationItemType.NOTIFICATIONITEMTYPE_UNKNOWN && isNil(notification.CustomHeader)) {
        throw new Error('[NotificationsAdapterService#validateNotification] for \'Unknown\' topic \'CustomHeader\' is not optional');
    }

    return notification;
}

export function decodeHistorical(data: Uint8Array): Array<gateway.INotificationBarebone> {
    try {
        return gateway.HistoricalNotificationsResponse.decode(data).Notifications;
    } catch (error) {
        AlkLogger.error(
            `[NotificationsAdapterService#decodeHistorical] Decoding error ${ data } ${ ''
            } not decode to HistoricalNotificationsResponse message`,
        );
        throw error;
    }
}

export function decodeRealtime(data: Uint8Array): Array<gateway.INotification> {
    try {
        return gateway.NotificationsResponse.decode(data).Notifications;
    } catch (error) {
        AlkLogger.error(
            `[NotificationsAdapterService#decodeRealtime] Decoding ${ ''
            } error ${ data }  not decode to AuditResponse message`);
        throw error;
    }
}

